var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "home-top-progress" }, [
      _c("div", { staticClass: "home-top-progress_text" }, [
        _c(
          "div",
          { staticClass: "home-num" },
          [
            _vm.isBigNumber
              ? _c("big-number", { attrs: { number: _vm.num } })
              : _c("span", [_vm._v(_vm._s(_vm.splitK(_vm.num, "int")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "home-progress-bottom",
          domProps: { innerHTML: _vm._s(_vm.desc) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }